import { render } from "./HiDateTimeDisplay.vue?vue&type=template&id=6e1a84b6"
import script from "./HiDateTimeDisplay.vue?vue&type=script&lang=js"
export * from "./HiDateTimeDisplay.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__